import { IClickToCallCallEnergy } from './clickToCallEnergy.models';
import { API, CONSUMER_CMS_DEFAULT, IAppSession, useCmsConfig } from '@vfit/consumer/data-access';
import {
  getFromLocalStorageByKey,
  useGenericNoCors,
  useTrackingProvider,
} from '@vfit/shared/data-access';
import { IClickToCallMeData } from '@vfit/shared/models';
import { useId, useState } from 'react';
import { ClickToCallEnergyTagging } from './clickToCallEnergy.tagging';
import ClickToCall from './components/clickToCallEnergyCard/clickToCallEnergy';

const ClickToCallEnergy = (props: IClickToCallCallEnergy) => {
  const { isReady: isReadyTagging } = useTrackingProvider();
  const { url, entryPoint } = props || {};
  const leadId = useId();
  // no-cors, "opaque"
  const [isSuccess, setIsSuccess] = useState(false);
  const ctcDataEnergy = useCmsConfig(
    CONSUMER_CMS_DEFAULT,
    API.CMS_GET_CLICK_TO_CALL_ENERGY_CONF
  ) as IClickToCallMeData;
  const { isLoading: isLoadingCTCEnergy, mutate: mutateCtcEnergy } = useGenericNoCors();
  const appSession: IAppSession = getFromLocalStorageByKey('appSession');
  const appItems = appSession?.items?.filter((el) => el?.type?.toLowerCase() === 'sim');
  const appNumbers = appItems?.map((el) => el?.value || '');

  const sendLead = (telephoneNumber: string) => {
    mutateCtcEnergy({
      endpoint: url,
      params: {
        lead_id: leadId,
        // marketing_cloud_visitor_id: window?.visitor?.getMarketingCloudVisitorID?.toString(),
        // product_name: pageProduct?.product_name,
        // product_id: pageProduct?.product_id,
        // product_category: pageProduct?.product_category,
        phone_number: telephoneNumber,
        entry_point: entryPoint,
      },
    });
    setIsSuccess(true);
  };

  return (
    <>
      {isReadyTagging && <ClickToCallEnergyTagging {...props} />}
      <ClickToCall
        clickToCallData={ctcDataEnergy}
        isSuccess={isSuccess}
        isLoading={isLoadingCTCEnergy}
        defaultNumber={appNumbers?.[0] || ''}
        onSubmit={sendLead}
        {...props}
      />
    </>
  );
};

export default ClickToCallEnergy;
